import {useEffect, useState} from 'react';

// This Hook Keeps track of a refs width.
// Using this to create my own breakpoints for certain containers
export const useContainerWidth = (ref) => {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (!ref.current) return;

        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                setWidth(entry.contentRect.width);
            }
        });

        resizeObserver.observe(ref.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, [ref]);

    return width;
};